import { Language } from '../../../types/language'
import { LocaleIdentifier } from '../../../types/localeIdentifier'
import { localeToLanguage } from '../../../utils/localeToLanguage'

const E_INVOICING_LINKS: Partial<Record<Language, string>> = {
  en: 'https://shine.co/en-de/help-center/create-and-send-an-e-invoice',
  da: 'https://shine.co/en-de/help-center/create-and-send-an-e-invoice',
  de: 'https://shine.co/de/help-center/category/e-rechnungen',
  fr: 'https://help.shine.fr/shine-facture/fr/articles/13402315-envoyer-des-factures-electroniques',
  nl: 'https://shine.co/nl/help-center/maak-en-verstuur-een-e-factuur',
}

export const getEInvoicingInfoLink = (locale: LocaleIdentifier) => {
  const language = (locale && localeToLanguage[locale]) || 'en'
  return E_INVOICING_LINKS[language]
}
